const FullscreenWrapper = ({ children }) => (
  <div className="mx-auto max-w-7xl shrink-0 grow basis-auto p-8 pt-24">
    {children}
  </div>
)

export default FullscreenWrapper
